import { Expose } from "class-transformer";

export class UpdateIssueDto {
  @Expose()
  location?: string;

  @Expose()
  description?: string;
}
